import { createFileRoute } from '@tanstack/react-router'

import { PackageDetail } from '@/pages/AssetLibrary/PackageDetail'

export const Route = createFileRoute('/_app/asset-library/$packageId/')({
  component: PackageDetailRoute,
})

function PackageDetailRoute() {
  const { packageId } = Route.useParams()
  return <PackageDetail packageId={packageId} />
}
